export default {
    botao_restaurar: 'Restore Cards Default',
    little_cards: {
        equipamentos_total: 'Total Equipment',
        equipamentos_ativos: 'Active Equipment',
        equipamentos_inativos: 'Inactive Equipment',
        resultados_hora: 'Results / Hour'
    },
    cards: {
        minimizar: 'Minimize Card',
        maximizar: 'Maximize Card',
        fechar: 'Close Card',
        equipment: 'Equipments',
        performance: 'Performance (Results/Hour)',
        horas_atras: 'Hours ago',
        qualityControl: 'Validation/Quality Control',
        triggers: 'Triggers',
        results: 'Latest Results',
        equipmentLogs: 'Equipment Errors/Logs',
        filtrar: 'Filter'
    },
    widgets: {
        QualityControl: {
            codigo_exame: 'Exam Code'
        },
        LatestResult: {
            codigo_exame: 'Exam Code',
            columns: {
                vns_equipamento: 'VNS/Equipment',
                recipiente: 'Recipient',
                paciente: 'Patient',
                data_hora: 'Date/Hour',
                status: 'Status',
                liberado: 'Released',
                alerta: 'Alert',
                bloqueado: 'Blocked',
                exame: 'Exam'
            },
            aviso_processamento: 'When releasing the exam it will be processed!',
            tem_certeza: 'Are you sure?',
            exame_liberado: 'Exam released!',
            sucesso: 'Success'
        },
        TriggerWidget: {
            editar_trigger: 'Edit Trigger',
            nome: 'Name',
            regra: 'Rule',
            acao: 'Action',
            editar: 'Edit'
        }
    },
    tour: {
        buttons: {
            pular_tour: 'Skip Tour',
            voltar: 'Return',
            proximo: 'Next',
            finalizar: 'Finalize',
        },
        descricao: {
            equipamentos_total: 'Displays the total number of vns registered!',
            equipamentos_ativos: 'Displays the amount of currently active vns!',
            equipamentos_inativos: 'Displays the amount of currently inactive vns!',
            resultados_hora: 'Displays the number of exams performed in the period of 1 hour',
            equipment: 'Displays operational details of managed equipment, including: Name, Status, Up/Down Time',
            performance: 'Displays the volume of exams being processed by the equipment, showing its usage evolution.',
            qualityControl: 'It presents the values obtained from the results of the quality control tests applied to managed equipment.',
            triggers: 'Displays Triggers related to release, blocking, alert rules, etc.',
            results: 'It presents the results received by date, time, recipient ID, status and general query.',
            equipmentLogs: 'Monitor the errors/flags/status issued by the equipment.'
        }
    },
    liberar_exame: {
        deseja_desbloquear: 'Do you wish to unblock?',
        desbloquear: 'Unblock',
        sim: 'Yes',
        nao: 'No',
        fechar: 'Close'
    }    
}
